import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { FetchLandingPageAction } from "../../redux/action/LandingPageAction";
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { getUserClaims } from "../../utils/auth/unified-auth";
import { useAuth } from "../../utils/auth/useAuth";
import { appConfig } from "../../mocks/appConfig";
import { appConfigUAT } from "../../mocks/appConfig-uat";
import { localStoreKeys } from "../../constants/localStoreKeys";
import { getRoles, getSectors } from "../KPIOverview/KpiUtils";
import CommodityPageHeader from '../../components/Header/CommodityPageHeader';
import Phase2_Banner from '../../assets/Phase2_Banner.svg'
import AppCard from "../../components/Cards/AppCard";
import MainHeader from "../../components/Header/Header";
import Sidebar from "../../components/Sidebar/Sidebar";
import reset_icon from "../../../src/assets/reset_icon.svg";
import { LoadingSpinner, Button, CardV2, Modal } from "pepsico-ds";
import InfoIcon from '../../components/Icons/InfoIcon'
import CustomButtons from '../../components/Cards/CustomButtons'
import "./Landing.scss";
import "../../components/Layout/Layout.scss";
import { useToast } from '../../components/Toast/ToastContext';
import { SaveTilesOrderAction, resetToDefaultTilesOrderAction } from '../../redux/action/KpiCardsTileAction';
import WidgetPanel from "../../components/Button/WidgetPanel";
import Info from '../../assets/Info.svg'
import Vector from '../../assets/Vector.png'
import { FetchTileKpiOverviewAction } from '../../redux/action/LandingPageAction';
import { addCategoryManagementCardIfMissing, addCoManCardIfMissing, addCompassCardIfMissingPGCSUser, addProcurementPerformanceCardIfMissing, call7DaysNpsLogic, dragEndHandle, timerCardLayout, formatDate } from "../../utils/utils";
import { useTour } from '../../routes/JoyrideProvide';
import { useLoginEffects } from "../WalkmeTour/UseLoginEffects";
import ContractingCard from "../../components/Cards/ContractingCard";
import { urlConstants } from '../../constants/urlConstants';





const { Content } = Layout;

function LandingPage({isShowFooter}) {
	const dispatch = useDispatch();
	const { authState, authInstance } = useAuth();
	const [isAmesaUser, setIsAmesaUser] = useState(false);
	const [isAPACUser, setIsAPACUser] = useState(false);
	const [userInfo, setUserInfo] = useState({});
	const [flag, setflag] = useState(true)
	const [newAppList, setNewAppList] = useState([])
	const appList = window.ENV === 'PROD' ? appConfig : appConfigUAT;
	const [okaUser, setOkaUser] = useState(null);
	const [isUserDataFetched, setIsUserDataFetched] = useState(false)
	const { showToast } = useToast();

	const [allowMovement, setAllowMovement] = useState(false);
    const [resetTilesFlag, setResetTilesFlag] = useState(false);
    const [inactiveModal, setInactiveModal] = useState(false);
    const [cardUpdatedList, setCardUpdatedList] = useState([]);
    const [cardDataObjects, setCardDataObjects] = useState([]);
    const [initialKpiCardsList, setInitialKpiCardsList] = useState([])
	const [loader, setLoader] = useState(false)
    const [isTilesOrderSaved, setIsTilesOrderSaved] = useState(false)
    const [disableResetSaveBtn, setDisableResetSaveBtn] = useState(true)
    const [tourModal, setTourModal] = useState(true)

	const initialKpiTilesOrderData = useSelector((state) => state.getTileKpiOverviewReducer);
    
    const savedTilesOrderData = useSelector((state) => state.getSaveTilesOrderReducer);

    const resetToDefaultTilesOrderData = useSelector((state) => state.getResetToDefaultTilesOrderReducer);

	const [saveReset, setSaveReset] = useState('')

	const { startTour } = useTour();

	const location = useLocation();

	const isStartTour = useSelector((state) => state?.localData?.data[localStoreKeys.isStartTour]);
	const userAccessData = useSelector((state) => state.getUserAccessReducer);
	const showAwards = userAccessData?.showAwards;

	

	// const cardDataObjects = convertCapabilitiesToConstants(newAppList);
	/* istanbul ignore next */
	useEffect(() => {
		
		async function fetchUserInfo() {
			const user = await getUserClaims();
			if (!user) {
				console.error('Failed to fetch user claims');
				return;
			}
			setUserInfo(user);
			setOkaUser(user);
			localStorage.setItem('userInfoEmailID', btoa(JSON.stringify(user?.useremail || user?.email)))
			setLoader(true)
			dispatch(FetchLandingPageAction(user));
			setIsUserDataFetched(true)
		}
		fetchUserInfo();
		// dispatch(FetchTileKpiOverviewAction({email:JSON.parse(atob(localStorage.getItem('userInfoEmailID')))}));
	}, []);

	const userData = useSelector((state) => state.getLandingPageReducer);
	const isPGCSUser = userData?.isPGCSUser === true || userData?.isPGCSUser === "true";
	const isTerzoUser = userData?.isTerzoUser === true || userData?.isTerzoUser === "true";
	const isIcertisUser = userData?.isIcertisUser === true || userData?.isIcertisUser === "true";

	useLoginEffects(userData);

	/* istanbul ignore next */
		useEffect(() => {
			// Skip if we're in loading state
			if (userData?.type === 'LOADING_LANDING_PAGE_ACTION') {
				console.log('Waiting for user data to load...');
				return;
			}

			console.log('FullStory data check:', {
				hasFS: !!window.FS,
				hasUserData: !!userData,
				hasDetails: !!userData?.details,
				hasUserAttribute: !!userData?.userAttribute,
				type: userData?.type
			});
			// Only proceed if we have FullStory and actual user data (not loading state)
			if (window.FS && userData?.type === 'SUCCESS_LANDING_PAGE_ACTION' && okaUser?.gpid) {
				console.log('Updating FullStory with user data');
				try {
					window.FS('setIdentity', {
						uid: okaUser.gpid?.toString(),
						properties: {
							displayName: okaUser?.name,
							procurementHub_emailId: okaUser?.useremail,
							procurementHub_name: okaUser?.name,					
							procurementHub_bu: userData?.userAttribute?.bu,
							procurementHub_l0: userData?.userAttribute?.l0,
							procurementHub_l1: userData?.userAttribute?.l1,
							procurementHub_l2: userData?.userAttribute?.l2,
							procurementHub_sector: userData?.userAttribute?.sector,
							procurementHub_defaultRole: userData?.defaultRole
						},
					});
					console.log('User data has been captured by FS');
				} catch (error) {
					console.error('Error setting FullStory identity:', error);
				}
			} else {
				console.warn('FullStory or user data not available:', {
					hasFS: !!window.FS,
					hasUser: !!userData,
					type: userData?.type,
					gpid: !!userData?.gpid
				});
			}
		}, [userData, okaUser]);

	/* istanbul ignore next */
	useEffect(() => {
		const Roles = getRoles(userData.details);
		const defaultRole = Roles.find(item => item.displayText === userData.defaultRole);
		const userRoleInfo = userData.details?.find(item => item.role === defaultRole?.displayText);
		// dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
		const sectorsArray = getUniqueSectors(userData.details);

		if (sectorsArray.length === 1 && sectorsArray[0] === 'AMESA') {
			setIsAmesaUser(true);
		}
		
		if (sectorsArray.length === 1 && sectorsArray[0] === 'APAC') {
			setIsAPACUser(true);
		}

		if (userData?.feedbackFormUrl && flag) {
			dispatch(setKeyValue({ key: localStoreKeys.feedbackFormUrl, value: userData?.feedbackFormUrl }));
			setflag(false)
		}

			// const now = Date.now(); // current timestamp in milliseconds

            // const responseDate = new Date(userData?.mostRecentDate).getTime(); // convert to timestamp in ms

            // const diffInMs = Math.abs(now - responseDate); // difference in milliseconds

            // const daysDiff = diffInMs / (1000 * 60 * 60 * 24); // convert ms to days

            // if (daysDiff >= 7) {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: false }))
            // } else {
            //     dispatch(setKeyValue({ key: localStoreKeys.isNPSSubmittedRecently, value: true }))
            // }

		call7DaysNpsLogic(dispatch, userData)

			
	}, [userData]);

	/* istanbul ignore next */
	useEffect(()=> {
		
		// let userInfoEmailID = JSON.parse(atob(localStorage.getItem('userInfoEmailID')));
		

		if (isUserDataFetched && userData && userData.type === "SUCCESS_LANDING_PAGE_ACTION") {
			const pgcsVisibleApps = ["Ariba Test", "Ariba Prod", "Ariba Training"];
			const pgcsHiddenApps = ["Cockpit - Global", "Cockpit - AMESA", "Cockpit - APAC"];

			setNewAppList(appList.map(config => {
				if (["Spend Analytics", "Contracting", "Supplier Performance", "Procurement Performance", "CoMan Automation"].includes(config.capability_name)) {
				  return {
					...config,
					apps: config.apps.map(app => {
					  let display = true;
			  
					  if (["AMESA Contract Analytics", "CoMan Automation", "AMESA PBI"].includes(app.app)) { // 
						display = isAmesaUser;
					  } else if (app.app === "T-Contract" || app.app === "Performance Scorecard") {
						display = isAPACUser;
					  }

					  if (pgcsVisibleApps.includes(app.app)) {
						display = isPGCSUser;
					  }
			  
					  return {
						...app,
						display
					  };
					})
				  };
				}
		
				if(["Supplier Discovery"].includes(config.capability_name)) {
					return {
						...config,
						apps: config.apps.map((app => {
							if(app.app == "Forestreet"){
								return{
									...app,
									url: `https://platform.forestreet.com/sign-in-sso?email=${userInfo?.email}`
								};
							}
							return app
						}))
					}
				}
				
				if(["Productivity Report"].includes(config.capability_name) && !userData?.prAccess){
					return{
						...config,
						info: "",
						apps: config.apps.filter(app => app.app !== "PR Dashboard")
					}
				}

				if (isPGCSUser) {
					return {
						...config,
						apps: config.apps
							.filter(app => app.app !== "Archlet")
							.map(app => ({
								...app,
								display: pgcsHiddenApps.includes(app.app) ? false : (pgcsVisibleApps.includes(app.app) ? true : app.display)
							}))
					}
				}

				return {
					...config,
					apps: config.apps.map(app => ({
						...app,
						display: pgcsVisibleApps.includes(app.app) ? false : app.display
					}))
				}
				// return config;
			}))
			
			dispatch(FetchTileKpiOverviewAction({email:JSON.parse(atob(localStorage.getItem('userInfoEmailID')))}));
			setLoader(true)
		}
		
	}, [userData, isAmesaUser, isAPACUser, isPGCSUser]);

	/* istanbul ignore next */
	useEffect(() => {
		if (!newAppList?.length) return;

		setNewAppList(prevAppList => {
			let hasChange = false;
			const updatedAppList = prevAppList.map(config => ({
				...config,
				apps: config.apps.map(app => {
					if (app.app === "Icertis") {
						if (app.display !== isIcertisUser) {
							hasChange = true;
							return {
								...app,
								display: isIcertisUser
							};
						}
						return app;
					}

					if (app.app === "Terzo") {
						if (app.display !== isTerzoUser) {
							hasChange = true;
							return {
								...app,
								display: isTerzoUser
							};
						}
						return app;
					}

					return app;
				})
			}));

			return hasChange ? updatedAppList : prevAppList;
		});
	}, [newAppList, isIcertisUser, isTerzoUser])


	/* istanbul ignore next */
	useEffect(() => {

		// timerCardLayout(allowMovement, inactiveModal, setInactiveModal, setAllowMovement)

		const intervalId = timerCardLayout(
				allowMovement,
				inactiveModal,
				setInactiveModal,
				setAllowMovement
		);
		
		if(!allowMovement){
			if(resetToDefaultTilesOrderData && resetToDefaultTilesOrderData?.type == "SUCCESS_RESET_TO_DEFAULT_TILES_ORDER_ACTION" && saveReset=="ResetToDefault"){
				// 
				// let transformedCardsValue = transformCards(resetToDefaultTilesOrderData?.tilesOrderDetails)
				// 
				// setInitialKpiCardsList(transformedCardsValue)
				// setLoader(false)
			}
			else if(savedTilesOrderData && savedTilesOrderData?.type == "SUCCESS_SAVE_TILES_ORDER_ACTION" && saveReset=="Save"){
				
				let transformedCardsValue = transformCards(savedTilesOrderData?.tilesOrderDetails)
				
				setInitialKpiCardsList(transformedCardsValue)
				// setLoader(false)
			}
			else if(initialKpiTilesOrderData && initialKpiTilesOrderData?.type == "SUCCESS_TILE_KPI_OVERVIEW_ACTION" && saveReset!=="Save" && saveReset!=="ResetToDefault"){
				
				let transformedCardsValue = transformCards(initialKpiTilesOrderData?.tilesOrderDetails)
				if(loader){
					
					setInitialKpiCardsList(transformedCardsValue)
				}
				
				setLoader(false)
			}
			
		}

		return () => {
			if (intervalId) {
			clearInterval(intervalId);
			}
		};

	
		
	}, [allowMovement, inactiveModal, cardUpdatedList, initialKpiTilesOrderData,savedTilesOrderData]);
	/* istanbul ignore next */
	useEffect(()=>{
		isShowFooter(allowMovement)
	}, [allowMovement])

	// useEffect(()=>{
		  
	// 	if(resetToDefaultTilesOrderData && resetToDefaultTilesOrderData?.type == "SUCCESS_RESET_TO_DEFAULT_TILES_ORDER_ACTION" && saveReset=="ResetToDefault"){              
	// 		
	// 		let transformedCardsValue = transformCards(resetToDefaultTilesOrderData?.tilesOrderDetails)
            
    //         setInitialKpiCardsList(transformedCardsValue)
	// 		// setLoader(false)
    //     }
	// 	else if(savedTilesOrderData && savedTilesOrderData?.type == "SUCCESS_SAVE_TILES_ORDER_ACTION" && saveReset=="Save"){           
	// 		
	// 		let transformedCardsValue = transformCards(savedTilesOrderData?.tilesOrderDetails)
            
    //         setInitialKpiCardsList(transformedCardsValue)
	// 		// setLoader(false)
    //     }
    //     else if(initialKpiTilesOrderData && initialKpiTilesOrderData?.type == "SUCCESS_TILE_KPI_OVERVIEW_ACTION"){         
	// 		
	// 		let transformedCardsValue = transformCards(initialKpiTilesOrderData?.tilesOrderDetails)
            
    //         if(loader){
	// 			setInitialKpiCardsList(transformedCardsValue)
	// 		}
	// 		// setLoader(false)
	// 	}

	// }, [savedTilesOrderData, resetToDefaultTilesOrderData])

	/* istanbul ignore next */
	useEffect(()=>{
        
		if(allowMovement || resetTilesFlag){
				if(resetToDefaultTilesOrderData && resetToDefaultTilesOrderData?.type == "SUCCESS_RESET_TO_DEFAULT_TILES_ORDER_ACTION" && saveReset=="ResetToDefault"){                      
					let transformedCardsValue = transformCards(resetToDefaultTilesOrderData?.tilesOrderDetails)
					
					setInitialKpiCardsList(transformedCardsValue)
				}
				else if(savedTilesOrderData && savedTilesOrderData?.type == "SUCCESS_SAVE_TILES_ORDER_ACTION" && saveReset=="Save"){ 
					let transformedCardsValue = transformCards(savedTilesOrderData?.tilesOrderDetails)
					
					setInitialKpiCardsList(transformedCardsValue)
				}
				else if(initialKpiTilesOrderData && initialKpiTilesOrderData?.type == "SUCCESS_TILE_KPI_OVERVIEW_ACTION"){ 
					let transformedCardsValue = transformCards(initialKpiTilesOrderData?.tilesOrderDetails)
					
					// if(loader){
						
						setInitialKpiCardsList(transformedCardsValue)
					// }
				}
		}

		if(saveReset == "ResetToDefault"){
			if(resetToDefaultTilesOrderData && resetToDefaultTilesOrderData?.type == "SUCCESS_RESET_TO_DEFAULT_TILES_ORDER_ACTION" ){                      
				let transformedCardsValue = transformCards(resetToDefaultTilesOrderData?.tilesOrderDetails)
				
				setInitialKpiCardsList(transformedCardsValue)
			}
		}
		
			// setResetTilesFlag(false)
	}, [allowMovement, resetTilesFlag, saveReset, resetToDefaultTilesOrderData])

	// useEffect(()=>{
	// 	if(resetToDefaultTilesOrderData && resetToDefaultTilesOrderData?.type == "SUCCESS_RESET_TO_DEFAULT_TILES_ORDER_ACTION" ){
				
	// 		let transformedCardsValue = transformCards(resetToDefaultTilesOrderData?.tilesOrderDetails)
	// 		
	// 		setInitialKpiCardsList(transformedCardsValue)
	// 	}

	// },[resetToDefaultTilesOrderData])

	/* istanbul ignore next */
	useEffect(()=>{
		let x = convertCapabilitiesToConstants(newAppList)
		setCardDataObjects(x)
	},[newAppList])

	/* istanbul ignore next */
    // useEffect(()=>{
	// 	console.log("hideTour: ", localStorage.getItem('hideTour'))
	// 	const hideTour = localStorage.getItem('hideTour') === 'true';
	// 	if (userData?.isWalkMeEnabled && !hideTour) {
	// 	startTour();
	// 	}
		
	// },[userData])
    /* istanbul ignore next */
	//  useEffect(() => {
	// 	const shouldAnimate = sessionStorage.getItem("showLoginAnimation");

	// 	if (shouldAnimate !== "true") return;

	// 	const observer = new MutationObserver(() => {
	// 		const element = document.querySelector(".rocket-wrapper");

	// 		if (element) {
	// 		element.classList.add("animate-blue");

	// 		element.addEventListener(
	// 			"animationend",
	// 			() => {
	// 			element.classList.remove("animate-blue");
	// 			},
	// 			{ once: true }
	// 		);
	// 		sessionStorage.removeItem("showLoginAnimation");
	// 		observer.disconnect(); // stop observing
	// 		}
	// 	});

	// 	observer.observe(document.body, {
	// 		childList: true,
	// 		subtree: true,
	// 	});

	// 	return () => observer.disconnect();
	// }, []);
	/* istanbul ignore next */
	useEffect(()=>{
		if(allowMovement){
			setAllowMovement(false)
			setCardUpdatedList([])
			setResetTilesFlag(true)

			setDisableResetSaveBtn(true)
		}
		dispatch(setKeyValue({ key: localStoreKeys.isStartTour, value: false }))
	},[isStartTour])

	/* istanbul ignore next */
	function convertCapabilitiesToConstants(data) {
		// const modifiedData = data.filter(item => {
		// 	// Keep everything except the specific object to remove
		// 	if (item.capability_name === "Procurement Performance") {
		// 	  const hasMatchingApp = item.apps.some(
		// 		a => a.app === "Performance Scorecard" && a.display === false
		// 	  );
		  
		// 	  // If the condition matches → REMOVE this object
		// 	  if (hasMatchingApp) {
		// 		return false;
		// 	  }
		// 	}
		  
		// 	return true;
		//   });
		  
		const result = {};
	  
		data.forEach(item => {
		  // Convert capability name to camel case & remove special characters
		  const key = item.capability_name
			.replace(/[^a-zA-Z0-9 ]/g, '')       // remove special characters
			.split(' ')
			.map((word, index) =>
			   word.charAt(0).toUpperCase() + word.slice(1)
			)
			.join('') + "CardData";

		  if (item.capability_name === "Contracting") {
			const allApps = Array.isArray(item.apps) ? item.apps : [];
			const appsAnalytics = allApps.filter(app => app?.app === "Terzo");
			const appsCLM = allApps.filter(app => app?.app !== "Terzo");
			const { apps, ...restItem } = item;

			result[key] = {
				...restItem,
				appsAnalytics,
				appsCLM
			};
			return;
		  }
		  if (item.capability_name === "Sourcing (Launch RFx, Negotiation)") {
			const allApps = Array.isArray(item.apps) ? item.apps 
													 : [];
			const appsAnalytics = allApps
									.filter(app => app?.app === "Keelvar");
			const appsCLM = allApps
								.filter(app => app?.app !== "Keelvar");
			const { apps, ...restItem } = item;

			result[key] = {
				...restItem,
				appsAnalytics,
				appsCLM
			};
			return;
		  }

		  result[key] = item;
		});
	  
		return result;
	  }

	/* istanbul ignore next */
	function getUniqueSectors(data) {
		const sectors = new Set();
		data?.forEach(item => {
			item?.roleDetail?.forEach(detail => {
				if (detail.sector) {
					sectors.add(detail.sector);
				}
			});
		});
		return Array.from(sectors);
	}

	// OLDER APP FILTERING LOGIC
	// const newAppList = appList.map(config => {
	// 	if (["Spend Analytics", "Contracting", "Supplier Performance"].includes(config.capability_name)) {
	// 		return {
	// 			...config,
	// 			apps: config.apps.map(app => ({
	// 				...app,
	// 				display: isAmesaUser || !["CoMan Automation", "AMESA Contract Analytics", "AMESA PBI"].includes(app.app)
	// 			}))
	// 		};
	// 	}
	// 	return config;
	// });



	// const newAppList = appList.map(config => {
	// 	if (["Spend Analytics", "Contracting", "Supplier Performance", "Procurement Performance"].includes(config.capability_name)) {
	// 	  return {
	// 		...config,
	// 		apps: config.apps.map(app => {
	// 		  let display = true;
	  
	// 		  if (["CoMan Automation", "AMESA Contract Analytics", "AMESA PBI"].includes(app.app)) {
	// 			display = isAmesaUser;
	// 		  } else if (app.app === "T-Contract" || app.app === "Performance Scorecard") {
	// 			display = isAPACUser;
	// 		  }
	  
	// 		  return {
	// 			...app,
	// 			display
	// 		  };
	// 		})
	// 	  };
	// 	}

	// 	if(["Supplier Discovery"].includes(config.capability_name)) {
	// 		return {
	// 			...config,
	// 			apps: config.apps.map((app => {
	// 				if(app.app == "Veridion"){
	// 					return{
	// 						...app,
	// 						url: `https://platform.veridion.com/?sso_hint=${userData?.email}`
	// 					};
	// 				}
	// 				return app
	// 			}))
	// 		}
	// 	}
	// 	return config;
	// });

	/* istanbul ignore next */
	function countVisibleApps(apps) {
		return apps.filter(app => app.display === true).length;
	  }
	
	/* istanbul ignore next */  
	const transformCards = (cardsConfig) => {
        if (!Array.isArray(cardsConfig)) return [];
        // if(userAccessibleSectors.length>0 && categoriesLevel0.length>0) {
        //     const processedCardConfig = checkAndRemoveCoMan(cardsConfig)
			// const cardDataObjects = x;
			// setLoader(true)
			const shouldRemoveProcurementPerformance = 
					isAPACUser === false ||
					newAppList.some(cap =>
						cap.apps?.some(app =>
						app.app === "Performance Scorecard" && app.display === false
						)
			);

			let resultCards = cardsConfig.filter(card =>
				shouldRemoveProcurementPerformance ? card.phCardId !== "procurement-performance-card" : true
			);

			const shouldRemoveComanCard = 
					isAmesaUser === false ||
					newAppList.some(cap =>
						cap.apps?.some(app =>
						app.app === "CoMan Automation" && app.display === false
						)
			);

			resultCards = resultCards.filter(card =>
				shouldRemoveComanCard ? card.phCardId !== "coman-card" : true
			);

			resultCards = resultCards.filter(card =>
				isPGCSUser ? card.phCardId !== "compass-card" : card.phCardId !== "pgcs-analytics-card"
			);

			let returnVal =  resultCards?.map(card => {
				const cardId = card["phCardId"];
				// Determine which component to use based on card-id
				let componentSlot;
				let dataVar;
				let capabilityName;
			
				if (cardId === "spend-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.SpendAnalyticsCardData?.capability_name}
										cardDesc={cardDataObjects?.SpendAnalyticsCardData?.capability_desc}
										apps={cardDataObjects?.SpendAnalyticsCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.SpendAnalyticsCardData}
										disabled={allowMovement}
										
									/>
					dataVar = "spendCardData";
					capabilityName = "spend";
				} 
				else if (cardId === "compass-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.CommodityBuyPlanCardData?.capability_name}
										cardDesc={cardDataObjects?.CommodityBuyPlanCardData?.capability_desc}
										apps={cardDataObjects?.CommodityBuyPlanCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.CommodityBuyPlanCardData}
										disabled={allowMovement}
										
									/>
					dataVar = "compassCardData";
					capabilityName = "compass";
				} else if (cardId === "market-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.MarketIntelligenceCardData?.capability_name}
										cardDesc={cardDataObjects?.MarketIntelligenceCardData?.capability_desc}
										apps={cardDataObjects?.MarketIntelligenceCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.MarketIntelligenceCardData}
										disabled={allowMovement}
										
									/>
					dataVar = "marketIntelCardData";
					capabilityName = "marketIntel";
				} 
				else if (cardId === "sustainability-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.SustainabilityScoreCardData?.capability_name}
										cardDesc={cardDataObjects?.SustainabilityScoreCardData?.capability_desc}
										apps={cardDataObjects?.SustainabilityScoreCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.SustainabilityScoreCardData}
										disabled={allowMovement}
										
									/>
					dataVar = "sustainabilityCardData";
					capabilityName = "sustainability";
				} else if (cardId === "scm-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.ShouldCostModellingCardData?.capability_name}
										cardDesc={cardDataObjects?.ShouldCostModellingCardData?.capability_desc}
										apps={cardDataObjects?.ShouldCostModellingCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.ShouldCostModellingCardData}
										disabled={allowMovement}
										
									/>
					dataVar = "";
					capabilityName = "";
				} else if (cardId === "coman-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.CoManAutomationCardData?.capability_name}
										cardDesc={cardDataObjects?.CoManAutomationCardData?.capability_desc}
										apps={cardDataObjects?.CoManAutomationCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.CoManAutomationCardData}
										disabled={allowMovement}
										
									/>
					dataVar = "";
					capabilityName = "";
				} else if (cardId === "resilinc-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.SupplierRiskCardData?.capability_name}
										cardDesc={cardDataObjects?.SupplierRiskCardData?.capability_desc}
										apps={cardDataObjects?.SupplierRiskCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.SupplierRiskCardData}
										disabled={allowMovement}
										
									/>
					dataVar = "";
					capabilityName = "";
				} 
				else if (cardId === "forestreet-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.SupplierDiscoveryCardData?.capability_name}
										cardDesc={cardDataObjects?.SupplierDiscoveryCardData?.capability_desc}
										apps={cardDataObjects?.SupplierDiscoveryCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.SupplierDiscoveryCardData}
										disabled={allowMovement}
										
									/>
					dataVar = "";
					capabilityName = "";
				} else if (cardId === "archlet-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.SourcingLaunchRFxNegotiationCardData?.capability_name}
										cardDesc={cardDataObjects?.SourcingLaunchRFxNegotiationCardData?.capability_desc}
										apps={cardDataObjects?.SourcingLaunchRFxNegotiationCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.SourcingLaunchRFxNegotiationCardData}
										disabled={allowMovement}
										
									/>
					componentSlot = <ContractingCard
										cardName={cardDataObjects?.SourcingLaunchRFxNegotiationCardData?.capability_name}
										cardDesc={cardDataObjects?.SourcingLaunchRFxNegotiationCardData?.capability_desc}

										appsAnalytics={cardDataObjects?.SourcingLaunchRFxNegotiationCardData?.appsAnalytics}
										appsCLM={cardDataObjects?.SourcingLaunchRFxNegotiationCardData?.appsCLM}

										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.SourcingLaunchRFxNegotiationCardData}
										disabled={allowMovement}
									/>
					dataVar = "";
					capabilityName = "";
				} else if (cardId === "contract-card") {
					componentSlot = <ContractingCard
										cardName={cardDataObjects?.ContractingCardData?.capability_name}
										cardDesc={cardDataObjects?.ContractingCardData?.capability_desc}
										// apps={cardDataObjects?.ContractingCardData?.apps}
										appsAnalytics={cardDataObjects?.ContractingCardData?.appsAnalytics}
										appsCLM={cardDataObjects?.ContractingCardData?.appsCLM}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.ContractingCardData}
										disabled={allowMovement}
										isTerzoUser={isTerzoUser}
									/>
					dataVar = "";
					capabilityName = "";
				} else if (cardId === "powersteering-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.ProductivityReportCardData?.capability_name}
										cardDesc={cardDataObjects?.ProductivityReportCardData?.capability_desc}
										apps={cardDataObjects?.ProductivityReportCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.ProductivityReportCardData}
										disabled={allowMovement}
										
									/>
					capabilityName = "";
				} else if (cardId === "r2p-insights-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.R2PInsightsCardData?.capability_name}
										cardDesc={cardDataObjects?.R2PInsightsCardData?.capability_desc}
										apps={cardDataObjects?.R2PInsightsCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.R2PInsightsCardData}
										disabled={allowMovement}
										
									/>
				} 
				else if (cardId === "category-management-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.CategoryManagementCardData?.capability_name}
										cardDesc={cardDataObjects?.CategoryManagementCardData?.capability_desc}
										apps={cardDataObjects?.CategoryManagementCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.CategoryManagementCardData}
										disabled={allowMovement}
										
									/>
				}
				else if (cardId === "procurement-performance-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.ProcurementPerformanceCardData?.capability_name}
										cardDesc={cardDataObjects?.ProcurementPerformanceCardData?.capability_desc}
										apps={cardDataObjects?.ProcurementPerformanceCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.ProcurementPerformanceCardData}
										disabled={allowMovement}
										
									/>
				}
				else if (cardId === "pgcs-analytics-card") {
					componentSlot = <AppCard
										cardName={cardDataObjects?.PGCSProcurementAnalyticsPortalCardData?.capability_name}
										cardDesc={cardDataObjects?.PGCSProcurementAnalyticsPortalCardData?.capability_desc}
										apps={cardDataObjects?.PGCSProcurementAnalyticsPortalCardData?.apps}
										isAmesaUser={isAmesaUser}
										item={cardDataObjects?.PGCSProcurementAnalyticsPortalCardData}
										disabled={allowMovement}
										
									/>
				}
				//
				else{

				}
			
				return {
					cardHeader: {},
					cardBody: {
					isDark: false,
					slot: componentSlot,
					type: 'slot',
					},
					className: `card-v2 card-item ${cardId}`,
				};
            });
			
			// setLoader(false)
            return returnVal
        // }
    };

	/* istanbul ignore next */
    const cancelTileMovement = () => {
        setAllowMovement(false)

        setCardUpdatedList([])
        setResetTilesFlag(true)

        setDisableResetSaveBtn(true)
        showToast('info', "You have exited layout mode. No changes were made to your layout.", {
            icon: <img src={Info} alt='image' style={{ width: '20px', height: '20px' }} />
        });
    }

	/* istanbul ignore next */
    const resetToDefaultMovement = () => {
        setAllowMovement(false)
        setDisableResetSaveBtn(true)
        setResetTilesFlag(false)
        setSaveReset("ResetToDefault")
        const reqObj = {
            emailId: userInfo?.email,
        };

        dispatch(resetToDefaultTilesOrderAction(reqObj))


        
        showToast('success', "Layout has been restored to default.", {
            icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
        });
		setCardUpdatedList([])
    }

	/* istanbul ignore next */
	const handleContinue = () => {
		setAllowMovement(true)
		setInactiveModal(false);
		// showToast('success', "You chose to continue editing. Inactivity timer has been reset.", {
		//     icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
		// });
	};
	/* istanbul ignore next */
	const handleExitEditorMode = () => {
		setAllowMovement(false)
		setInactiveModal(false);
		setDisableResetSaveBtn(true)
		showToast('info', "You were inactive for a while and have been exited from edit mode.", {
			icon: <img src={Info} alt='image' style={{ width: '20px', height: '20px' }} />
		});
	};
        
        // /* istanbul ignore next */
        // const resetTileMovement = () => {
        //     // setCurrentSortedAppList(savedSortedAppList);
        //     setCardUpdatedList([])
        //     setDisableResetSaveBtn(true)
        //     setResetTilesFlag(true)
        //     setAllowMovement(true)

        //     showToast('success', "Layout has been reset to default layout. Cancel to exit layout mode.", {
        //         icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
        //     });
        // }
	

        /* istanbul ignore next */
        const savedTilesOrder = () => {
            setDisableResetSaveBtn(true)
            setResetTilesFlag(false)
            setAllowMovement(false)
            setIsTilesOrderSaved(true)
            setSaveReset('Save')
            const saveCardsOrder = cardUpdatedList?.map(card => {
                const originalClassName = card?.content?.props?.className;
                const updatedCardVal = originalClassName.replace("card-v2 card-item ", "");
                return { phCardId: updatedCardVal };
              });

            // Append 'sortOrder' property
            let updatedSaveCardsOrder = saveCardsOrder.map((card, index) => ({
                ...card,
                sortOrder: index + 1
            }));
			if(isPGCSUser){
				updatedSaveCardsOrder = addCompassCardIfMissingPGCSUser(updatedSaveCardsOrder);
			}
            updatedSaveCardsOrder = addCoManCardIfMissing(updatedSaveCardsOrder);
			updatedSaveCardsOrder = addCategoryManagementCardIfMissing(updatedSaveCardsOrder);
			updatedSaveCardsOrder = addProcurementPerformanceCardIfMissing(updatedSaveCardsOrder);

            const tilesUpdatedOrder = {
                emailId: userInfo?.email,
                tilesOrderDetails: [...updatedSaveCardsOrder]  
            };
            
            dispatch(SaveTilesOrderAction(tilesUpdatedOrder))

            showToast('success', "Layout Saved", {
                icon: <img src={Vector} alt='image' style={{ width: '20px', height: '20px' }} />
            });

            setCardUpdatedList([])

        }

	/* istanbul ignore next */
	const enableTileCustomisation = () => {
		setAllowMovement(true);
	}

	const handleStartTour = () => {
		// startTour();
		// setTourModal(false)
	}



	/* istanbul ignore next */
	if(authState?.isAuthenticated){
		return(
			<>
			{/* <WidgetPanel /> */}
			<Layout >
					{/* <MainHeader /> */}
					<div style={{ display: "flex", background: "#D7E5F8", minHeight:"125vh"  }}>
						{/* <Sidebar /> */}
						{/* background: #F3F7FD */}
						
						<Content style={{ padding: "0 30px 30px 100px", background: "#D7E5F8" }}>  
							{/* {loader ? ( */}
							{Object.keys(userInfo).length === 0 || loader ? (
								<div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "calc(100vh - 64px)" }}>
									<LoadingSpinner size={{ height: "80px", width: "80px" }} />
								</div>
							) : (
								<>
									{/* <LandingPageHeader phase="1" /> */}
									<CommodityPageHeader header={"PepsiCo Procurement Hub"}
										subtext={"One gateway, endless possibilities."}
										subtext2={"Simplifying procurement - one click at a time."}
										image={Phase2_Banner}/>

									{showAwards && (
									<Row style={{ marginBottom: "16px" }}>
										<Col xs={24} sm={24} md={24} lg={24} xl={24}>
											<div className="procurement_awards_banner">
												<div className="procurement_awards_banner_left">
													<div className="procurement_awards_banner_text">
														<div className="procurement_awards_banner_title">
															Global Procurement Awards <span>2026</span>
														</div>
														<div className="procurement_awards_banner_subtext">
															The nominations are here! It's time to vote for the Procurement Awards.
														</div>
													</div>
												</div>
												<div className="procurement_awards_banner_actions">
													<Button
														className="procurement_awards_banner_button procurement_awards_banner_button--rollout"
														variant="secondary"
														size="large"
														text="GP Awards Rollout"
														iconLeading="chrome_reader_mode"
														onClick={()=>window.open(urlConstants.awardsPptUrl, "_blank")}
													/>
													<button
														type="button"
														className="procurement_awards_banner_button procurement_awards_banner_button--vote"
														onClick={()=>window.open(urlConstants.awardsFormUrl, "_blank")}
													>
														<span className="procurement_awards_banner_vote_circle" aria-hidden="true" />
														<span className="procurement_awards_banner_vote_content">
															<span className="material-icons-outlined procurement_awards_banner_vote_icon" aria-hidden="true">emoji_events</span>
															<span className="procurement_awards_banner_vote_text">Nominate now</span>
														</span>
													</button>
												</div>
											</div>
										</Col>
									</Row>
									)}

									<Col xs={12} sm={12} md={24} lg={24} xl={24}>
										<div className="landing_page_process_overview">
											<div className="landing_page_title"> Gateway to all Apps</div>
											<div className="landing_page_process_overview">
												<div className="current_datetime" style={{ color: '#013771', fontSize: 12, fontweight: 400 }}>{formatDate()}</div>
											</div>
										</div>
									</Col>
									<Row justify="end" style={{marginRight:"10px",marginTop:"10px"}}>

										<Button
												size="small"
												text="Customize Layout"
												variant="secondary"
												onClick={enableTileCustomisation}
												style={{position: 'relative', left: '10px', bottom: '7px', borderRadius: '4px', cursor:'pointer'}}
												disabled={allowMovement}
												iconLeading='create'
												className='home-customize-btn'
											/>
									</Row>
									<Row gutter={[20, 20]} style={{marginLeft: "0px", marginRight: "0px"}}>
									
										{initialKpiCardsList && initialKpiCardsList?.length>0  ?
										
										<>
											<div style={allowMovement ? { overflow: 'hidden !important' } : {}}>
												<CardV2
																	isDraggable={allowMovement ? true : false}  
																	// isDraggable
																	cardDataList={initialKpiCardsList}
																	// className='landing-static-kpi-card'
																	className={allowMovement ? "shuffle-card" : 'static-kpi-card'}
																	onDragEndHandler={(item, newIdx, oldIdx, updatedList) => dragEndHandle(item, newIdx, oldIdx, updatedList, setCardUpdatedList, setDisableResetSaveBtn)}
																	// className='static-kpi-card'
																	maxScrollHeight="90px"
																	sortableCardHeight="200px"
																	state="interactive"
																	style={{}}
																	type="basic"
																	viewport="desktop"
												/>

											</div>

											</> : <></>
										}
										{/* <br/> */}
										{/* <br/> */}
										{
											allowMovement && 
											(
												<>
													<br/>
													<footer className="tile-footer">
														<div style={{justifyContent: 'space-between', alignItems: 'center', display:"flex", width:'100%'}}>
															<div>
																<div className='tile-customized-text'>Customize Layout Mode</div>
																<div className='tile-customized-subtext'>Rearrange the dashboard cards to customize your experience</div>
															</div>
															<div style={{display: 'flex'}}>
																<Button
																	style={{margin:"0px 10px"}}
																	onClick={cancelTileMovement}
																	variant="tertiary"
																	text="Cancel"
																	size="medium"
																/>
																<Button
																	style={{margin:"0px 10px", borderRadius: '4px'}}
																	onClick={resetToDefaultMovement}
																	variant="secondary"
																	text="Reset to Default"
																	size="medium"
																/>
																<Button
																	disabled={disableResetSaveBtn}
																	style={{margin:"0px 10px", borderRadius: '4px'}}
																	onClick={savedTilesOrder}
																	variant="primary"
																	text="Save Layout"
																	size="medium"
																/>
															</div>
														</div>
													</footer>
												</>
											)
											
										}
										{
											inactiveModal && 
											<>
												<Modal
												showModal={inactiveModal}
												type="S"
												showLink={false}
												showAuxiliaryButton={false}
												showTertiaryButton={false}
												primaryButtonProps={{
													variant: 'primary',
													text: 'Continue',
													size: 'medium',
													onClick: handleContinue
												}}
												secondaryButtonProps={{
													variant: 'tertiary',
													text: 'Exit',
													size: 'medium',
													onClick: handleExitEditorMode
												}}
												onCloseModal={function oFe(){setInactiveModal(false)}}
												hideCloseButton
												closeOnOutsideClick={false}
												className="inactive-modal"
												>
													<div style={{}}>
														<div style={{fontSize: '22px', fontWeight: 'bold', marginBottom: '10px', color: '#3A3A3A'}}>Continue Editing ? </div>
														<div>You've been inactive for a while from editor mode.</div>
													</div>
												</Modal>
											</>
										}
									</Row>
								</>
							)}
						</Content>
					</div>
				</Layout>
				</>
		)
	}
}
export default LandingPage;

// latest working